export default {
	putBenefitGraph(state, payload) {
		state.benefitGraph = payload ?? []
	}
}
